import * as React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    singular?: string | React.ReactElement;
    plural?: string | React.ReactElement;
    zero?: string | React.ReactElement;
    resource?: string;
    count: number;
}

export const TextPluralization: React.FC<IProps> = (props) => {

    const { t } = useTranslation();

    if (props.count == 0) {
        let z = null;
        if (props.resource) {
            const resZKey = props.resource + "_zero";
            const resZ = t(resZKey);
            z = (resZ == resZKey) // Existe '_zero'?
                ? null
                : <span>{resZ}</span>;
        }

        if (z == null) z = (typeof props.zero == "string" ? <span>{props.zero}</span> : props.zero);

        if (z != null) return z;
    }

    if (props.count == 1) {
        const s = (props.resource != null) ? t(props.resource, { count: 1 }) : null;
        return s != null
            ? <span>{s}</span>
            : typeof props.singular == "string"
                ? <span>{props.singular.replace("{count}", props.count.toString())}</span>
                : props.singular;
    }
    else {
        const p = (props.resource != null) ? t(props.resource, { count: Math.max(2, props.count) }) : null;
        return p != null
            ? <span>{p}</span>
            : typeof props.plural == "string"
                ? <span>{props.plural.replace("{count}", props.count.toString())}</span>
                : props.plural || <span>&quot;?&quot;</span>;
    }
};